<template>
  <div>
    <div v-if="true" class="container">
      <before-form-header :title="$t('views.statistics.marketplaceStatistics')" class="over-header" description=""/>
      <p class="stat-under-header blue font-weight-bold">{{ $t('views.statistics.incomeInvestorsHave') }}<span>
      {{ parseFloat(investorsAverage).toFixed(2) }}%</span>{{ $t('views.statistics.toDate') }}<sup>
        <help-tooltip
            :tooltipText = "$t('views.statistics.showsTheWeighted')"></help-tooltip>
      </sup>
      </p>
      <loader v-if="isLoading"/>
      <template v-if="!isLoading">
        <b-table :items="tableData" :fields="tableFields" class="w-100 statistics-table" responsive="sm" @mouseover.native="setActiveBg($event)" @mouseleave.native="setActiveBg($event)">
          <template v-slot:head()="data">
            <span class="table-header">{{ $t(data.label) }}</span>
          </template>
          <template v-slot:head(lo_status)="data">
          <span class="table-header">{{ $t(data.label) }}
            <img id="lo_status" class="help-tooltip" alt="" v-bind:src="getSrc('help.svg')" v-b-tooltip.hover/>
          <b-tooltip target="lo_status" triggers="hover">
            <strong>{{ $t('views.statistics.active') }}</strong>{{ $t('views.statistics.originatorIs') }}<br/>
            <strong>{{ $t('views.statistics.suspended') }}</strong>{{ $t('views.statistics.ourMonitoring') }}<br/>
            <strong>{{ $t('views.statistics.defaulted') }}</strong>{{ $t('views.statistics.originatorHas') }}</b-tooltip>
          </span>
          </template>
          <template v-slot:head(buyback_initiated)="data">
          <span class="table-header">{{ $t(data.label) }}
            <img id="buyback_initiated" class="help-tooltip" alt="" v-bind:src="getSrc('help.svg')" v-b-tooltip.hover/>
            <b-tooltip target="buyback_initiated" triggers="hover">{{ $t('views.account.dLate3Tooltip') }}</b-tooltip>
          </span>
          </template>
          <template v-slot:head(listed_on_platform_all_time)="data">
          <span class="table-header">{{ $t(data.label) }}
            <img id="listed_on_platform_all_time" class="help-tooltip" alt="" v-bind:src="getSrc('help.svg')" v-b-tooltip.hover/>
            <b-tooltip target="listed_on_platform_all_time" triggers="hover">{{ $t('views.statistics.listedAssetsDenominated') }}</b-tooltip>
          </span>
          </template>
          <template v-slot:head(investable_on_platform)="data">
          <span class="table-header">{{ $t(data.label) }}
            <img id="investable_on_platform" class="help-tooltip" alt="" v-bind:src="getSrc('help.svg')" v-b-tooltip.hover/>
            <b-tooltip target="investable_on_platform" triggers="hover">{{ $t('views.statistics.listedAssetsDenominated1') }}</b-tooltip>
          </span>
          </template>
          <template v-slot:head(total_paid_to_investors)="data">
          <span class="table-header">{{ $t(data.label) }}
            <img id="total_paid_to_investors" class="help-tooltip" alt="" v-bind:src="getSrc('help.svg')" v-b-tooltip.hover/>
            <b-tooltip target="total_paid_to_investors" triggers="hover">{{ $t('views.statistics.totalPaidTo') }}</b-tooltip>
          </span>
          </template>
          <template v-slot:cell()="item">
          <span class="table-cell" v-bind:class="(item.field.key === 'loan_originator_name' || item.field.key === 'lo_status')?'clear-bg':''">
            {{ (item.field.key !== 'loan_originator_name' && item.field.key !== 'lo_status') ? item.value || 0 : '' | moneyFormatterWithoutCents }}
            {{ (item.field.key === 'loan_originator_name' || item.field.key === 'lo_status') ? item.value : '' }}
          </span>
          </template>
          <template v-slot:custom-foot="data">
            <td class="text-right"
                v-bind:class="(index>1&&index<5)?'lifetime':(index>4?'active-portfolio':'')"
                v-for="(item, index) in data.fields" v-bind:key="index">
              <strong>
                {{ (index === 0) ? ($t('views.statistics.labelTotal') + ':') : '' }}
                {{ (index > 1) ? (total(item.key).toFixed(2)) : '' | moneyFormatterWithoutCents }}</strong>
            </td>
          </template>
          <template #thead-top>
            <b-tr>
              <b-th class="text-right" colspan="2" variant="light"></b-th>
              <b-th class="text-center lifetime-header lifetime" colspan="3" variant="light">{{ $t('views.statistics.lifetimePortfolio') }}</b-th>
              <b-th class="text-center active-portfolio" colspan="7" variant="light">{{ $t('views.statistics.activePortfolio') }}</b-th>
            </b-tr>
          </template>
        </b-table>
        <hr/>
        <br/>
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="home-start-investing">
                <h2>{{ $t('views.statistics.startInvestingToday') }}</h2>
                <div class="detail-info">{{ $t('views.statistics.earnUpTo') }}</div>
                <get-started/>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/BarChart'
import LineChart from '@/components/LineChart'
import moneyMixin from '../mixins/money'
import Loader from '@/components/Loader'
import BeforeFormHeader from '@/components/BeforeFormHeader'
import HelpTooltip from '@/components/HelpTooltip'
import imageMixin from '@/mixins/image'
import GetStarted from '@/components/GetStarted'

export default {
  components: {GetStarted, HelpTooltip, BarChart, LineChart, BeforeFormHeader, Loader},
  mixins: [moneyMixin, imageMixin],
  data()
  {
    return {
      isLoading: true,
      investorsAverage: 0.00,
      tableData: {
        activity: [],
        overview: []
      },
      tableFields: [
        {
          key: 'loan_originator_name',
          label: 'views.statistics.labelOriginator',
          class: 'clear-bg'
        },
        {
          key: 'lo_status',
          label: 'views.statistics.labelStatusOfOriginator',
          class: 'clear-bg'
        },
        {
          key: 'listed_on_platform_all_time',
          label: 'views.statistics.labelInvestablePartOf',
          class: 'text-right lifetime'
        },
        {
          key: 'invested_on_platform_all_time',
          label: 'views.statistics.labelInvestedByInvestors',
          class: 'text-right lifetime'
        },
        {
          key: 'total_paid_to_investors',
          label: 'views.statistics.labelTotalPaidToInvestors',
          class: 'text-right lifetime'
        },
        {
          key: 'investable_on_platform',
          label: 'views.statistics.labelInvestablePartOf',
          class: 'text-right active-portfolio'
        },
        /*
                {
                  key: 'invested_by_investors',
                  label: 'Invested by investors',
                  class: 'text-right active-portfolio'
                },
        */
        {
          key: 'outstanding_to_investors',
          label: 'views.statistics.labelOutstandingBalance',
          class: 'text-right active-portfolio'
        },
        {
          key: 'current',
          label: 'views.statistics.labelCurrent',
          class: 'text-right active-portfolio'
        },
        {
          key: 'dpd1_30',
          label: 'views.statistics.labelOneToThirtyDays',
          class: 'text-right active-portfolio'
        },
        {
          key: 'dpd31_60',
          label: 'views.statistics.labelThirtyToSixtyDays',
          class: 'text-right active-portfolio'
        },
        {
          key: 'buyback_initiated',
          label: 'views.statistics.labelSixtyOrMore',
          class: 'text-right active-portfolio'
          /*
                  },
                  {
                    key: 'defaulted',
                    label: 'Defaulted',
                    class: 'text-right'
                  },
                  {
                    key: 'paid_back',
                    label: 'Paid back',
                    class: 'text-right'
          */
        }
      ],
      chartInvestedData: {
        labels: [],
        datasets: [
          {
            label: this.$t('views.statistics.datasetLabelCumulative'),
            backgroundColor: '#EC4C60',
            data: []
          }
        ]
      },
      chartOutstandingData: {
        labels: [],
        datasets: [
          {
            label: this.$t('views.statistics.datasetLabelActive'),
            backgroundColor: '#30A7FE',
            data: []
          }
        ]
      },
      chartOptions: {
        bezierCurve: false,
        maintainAspectRatio: false,
        xAxes: [{
          type: 'time',
          position: 'bottom'
        }]
      },
      selectedAssets: 'invested',
      graphSwitcherOptions: [
        {text: this.$t('views.statistics.datasetLabelCumulative'), value: 'invested'},
        {text: this.$t('views.statistics.datasetLabelActive'), value: 'outstanding'}
      ],
      loansFundedData: [
        [
          '2015',
          20000
        ],
        [
          '2016',
          120000
        ],
        [
          '2017',
          310000
        ],
        [
          '2018',
          400000
        ],
        [
          '2019',
          450000
        ],
        [
          '2020',
          520000
        ],
        [
          '2021',
          720000
        ]
      ],
      lineChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          easing: 'easeInOutBack'
        },
        legend: {
          display: false
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItems, data) {
              return '€' + tooltipItems.yLabel
            }
          }
        },
        scales: {
          yAxes: [{
            grid: {
              drawBorder: false,
              color: '#6D818F'
            },
            ticks: {
              beginAtZero: true,
              callback: function(value, index, values) {
                if (parseInt(value) >= 1000) {
                  return '€ ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                } else {
                  return '€ ' + value
                }
              }
            }
          }],
          xAxes: {
            display: true,
            grid: {
              display: false
            },
            ticks: {
              padding: 16,
              color: 'white',
              font: {
                family: 'Montserrat',
                weight: 600
              }
            }
          }
        }
      }
    }
  },
  mounted()
  {
    const axios = require('axios').default
    axios.get(process.env.VUE_APP_API_BASE_URL + 'statistics').then(response =>
    {
      this.tableData = response.data.overview

      this.chartOutstandingData.labels = this.chartInvestedData.labels = response.data.activity.map(month => month.month)
      this.chartOutstandingData.datasets[0].data = response.data.activity.map(month => month.invested)
      this.chartInvestedData.datasets[0].data = response.data.activity.map(month => month.outstanding)
      this.investorsAverage = response.data.average_earning
      this.isLoading = false
    }).catch((error) =>
    {
      console.log(error)
    })
  },
  methods:
      {
        total(name)
        {
          return this.tableData.reduce((accum, item) =>
          {
            let el = item[name]
            if (el === null || isNaN(el))
            {
              el = 0
            }
            if (accum === null || isNaN(accum))
            {
              accum = 0
            }
            return accum + parseFloat(el)
          }, 0)
        },
        setActiveBg(ev)
        {
          if (ev && ev.target && ev.target.className)
          {
            const fullClassName = ev.target.className
            if (fullClassName.includes('lifetime'))
            {
              this.updateBg('lifetime', '#c3eaef')
              this.updateBg('active-portfolio', 'transparent')
            }
            else if (fullClassName.includes('active-portfolio'))
            {
              this.updateBg('active-portfolio', '#c3eaef')
              this.updateBg('lifetime', 'transparent')
            }
            else
            {
              if ((!fullClassName.includes('table-cell') && !fullClassName.includes('table-header') && !fullClassName.includes('help-tooltip')) ||
                  fullClassName.includes('clear-bg')
              )
              {
                this.updateBg('active-portfolio', 'transparent')
                this.updateBg('lifetime', 'transparent')
              }
            }
          }
        },
        updateBg(type, color)
        {
          document.querySelectorAll('.' + type).forEach(e =>
              {
                e.style.backgroundColor = color
              }
          )
        }
      }
}
</script>
<style src="../assets/css/statistics.css" ></style>
<style lang="scss">

.radio-assets {
  text-align: center;

  .btn.focus,
  .btn-outline-primary:hover {
    box-shadow: none !important;
  }

  .btn-none {
    color: #30A7FE !important;
    border-color: #30A7FE !important;
  }

  .active {
    background-color: #30A7FE !important;
    border-color: #30A7FE !important;
    color: white !important;
  }
}
</style>
<style scoped lang="scss">
.chart {
  margin-top: 50px;
  width: 100%;
  height: 400px;
}

.table-header {
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 10px;
  text-align: center;
  /*text-transform: uppercase;*/
  color: #9DA0A6;
}

.table-cell {
  font-style: normal;
  line-height: 10px;
}

.stat-under-header {
  margin-top: -16px;
}

.lifetime-header {
  border-right: 1px solid #c3c3c3
}

.help-tooltip {
  width: 18px;
  height: 18px;
  margin-top: 4px;
  cursor: pointer;
}

.home-start-investing {
  text-align: center;
  margin-top: 80px;
  margin-bottom: 100px;
  font-style: normal;

  h2 {
    font-size: 36px;
    line-height: 40px;
    font-weight: bold;
    color: #000000;
  }

  .start-investing-img {
    margin-bottom: 40px;
    width: 100%;
    max-width: 590px;
  }

  .detail-info {
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    color: #9DA0A6;
  }
}
</style>
